import type { Folder } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import { findRecord } from '@warp-drive/utilities/json-api';

import { jsonApiOptions } from '../../../lib/json-api.ts';

/**
 * Finds a folder by path
 * @param path - The folder path (e.g., |clientId or |clientId|subfolder)
 * @returns JSON API request to find the folder with its files and subfolders
 */
export function findFolder(path: string) {
  return findRecord<Folder>(DataTypeContent.Folder, path, {
    ...jsonApiOptions,
    include: ['files', 'folders'],
  } as FindRecordOptions);
}
